module.exports = __webpack_public_path__ + "static/media/tyrannos.df1bb439.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bot_icons/tyrannos.png
// module id = 121
// module chunks = 0